import { createApp } from 'vue'
import router from "./router";
import "../static/css/app.css";
import "../static/css/common.css";
import { createPinia } from 'pinia'
const pinia = createPinia();
import { setupRouter } from "@/router";
import { setup } from '../plugins/elementPlus';
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueClipboard from 'vue-clipboard2';
// 【新增】Font Awesome 相关引入
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';

import { loadDirectives } from "@/directive"
import VueUeditorWrap from 'vue-ueditor-wrap'
import filters from '@/filters/index.js'

const app = createApp(App);

// 【新增】注册 Font Awesome 图标到库 & 注册图标组件
library.add(faMoon, faSun); // 添加需要用到的月亮、太阳图标到库
app.component('FontAwesomeIcon', FontAwesomeIcon); // 全局注册 Font Awesome 图标组件

// 原有逻辑：加载自定义指令
loadDirectives(app)
// 原有逻辑：注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
// 原有逻辑：使用各类插件
app.use(VueUeditorWrap)
app.use(pinia)
app.use(router)
app.use(VueClipboard)

app.mount('#app')
// 原有逻辑：全局组件注册（若需要可放开）
// app.component("tagGroup", tagGroup)
// 原有逻辑：全局属性配置
app.config.globalProperties.$filter = filters;

// 原有逻辑：路由、Element Plus 等 setup
setupRouter(app);
setup(app);